import {Base, model, endpoint, hasMany} from '@scoutgg/ftw/source/lib/model'

@model('Receiver')
@endpoint('receivers', {root: '/api'})
@hasMany('seasons')

export class Receiver extends Base {
}
